/**
 * 統一的 SVG icon 組件，從 DartSvgDefs 中按 name 取用 symbol。
 * 使用：<Icon name="cart" size={26} />  → 對應 #i-cart
 *      <Icon name="dart-full" size={200} type="dart" /> → 對應 #dart-full
 */
function Icon({ name, size = 24, type = 'icon', className, style, ...rest }) {
  const id = type === 'icon' ? `i-${name}` : name;
  return (
    <svg
      width={size}
      height={size}
      className={className}
      style={style}
      aria-hidden="true"
      {...rest}
    >
      <use href={`#${id}`} />
    </svg>
  );
}

export default Icon;
